import React, { useEffect, useRef, useState } from 'react'
import DataTable from '../../component/data_table/DataTable'
import { useDispatch, useSelector } from 'react-redux'
import { visitorListRes, visitorListTodo } from '../../redux/slices/visitor/VisitorList'
import Loader from '../../component/loader/Loader'
import { Button, Form } from 'react-bootstrap'
import SingleSelect from '../../component/input_filed/SingleSelect'
import SaveButton from '../../component/buttons/SaveButton'
import { useFormik } from 'formik'
import DatePicker from '../../component/input_filed/DatePicker'
import dayjs from 'dayjs'
import { CircleX } from 'lucide-react'
import { userListTodo } from '../../redux/slices/user/UserList'

export default function VisitorList() {
    const dispatch = useDispatch()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const [filterLoad, setFilterLoad] = useState(false)
    const visitorList = useSelector(state => state?.visitorList?.data?.data)
    const userList = useSelector(state => state?.userList?.data?.data)

    const status_option = [
        { value: 'check_in', label: 'Checked In' },
        { value: 'meeting_start', label: 'Meeting Started' },
        { value: 'meeting_end', label: 'Meeting Ended' },
        { value: 'check_out', label: 'Checked Out' },
        { value: 'rejected', label: 'Rejected' },
    ];

    const user_option = userList?.map(val => (
        { "value": val?._id, "label": val?.name }
    ))

    const initiaValues = {
        search: '',
        user: "",
        meeting_date: '',
        meeting_status: '',
        type: 'all',
    }

    const { values, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initiaValues,
        onSubmit: (values) => {
            setFilterLoad(true)
            const params = {
                search: '',
                meeting_person: values?.user || "",
                meeting_date: values.meeting_date ? dayjs(values.meeting_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
                meeting_status: values.meeting_status || '',
                type: 'all',
            }
            // console.log(params)
            dispatch(visitorListTodo({ params })).then(() => setFilterLoad(false))
        }
    })

    const statusRef = useRef();
    const userRef = useRef();

    const handleReset = () => {
        statusRef.current?.clearValue();
        userRef.current?.clearValue();
        setFieldValue('meeting_date', '')
        setBool(!bool)
    };

    const columnDefs = [
        {
            headerName: 'S.NO',
            maxWidth: 90,
            valueGetter: 'node.rowIndex + 1',
            filter: false,
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 70
        },
        {
            headerName: 'IMAGE',
            field: 'v_image',
            cellRenderer: (params) =>
                params?.value ? (
                    <img
                        src={process.env.REACT_APP_IMAGE_URL + `/${params.value}` || ''}
                        alt={params?.data?.name || 'gate'}
                        style={{ height: 40, width: 40, objectFit: 'cover', borderRadius: 4 }}
                        onError={(e) => { e.currentTarget.style.display = 'none' }}
                    />
                ) : null,

            filter: false,
            suppressHeaderMenuButton: true,
            sortable: false,
            floatingFilter: false,
            autoHeight: true,
        },
        { headerName: 'NAME', field: 'name', filter: 'agTextColumnFilter', suppressHeaderMenuButton: true, sortable: true, floatingFilter: false },
        { headerName: 'PHONE', field: 'phone', filter: 'agTextColumnFilter', suppressHeaderMenuButton: true, sortable: true, floatingFilter: false },
        { headerName: 'MEET TO', field: 'meeting_logs.0.meeting_person_data.name', cellRenderer: params => params?.data?.meeting_logs?.[0]?.meeting_person_data?.name || '-', filter: 'agTextColumnFilter', suppressHeaderMenuButton: true, sortable: true, floatingFilter: false },
        { headerName: 'DATE', field: 'added_date', cellRenderer: params => params?.data?.added_date ? dayjs(params?.data?.added_date).format('DD-MM-YYYY') : '-', filter: 'agTextColumnFilter', suppressHeaderMenuButton: true, sortable: true, floatingFilter: false },
        {
            headerName: 'COMPANY NAME', cellRenderer: params => {
                const value = params?.value || '';
                const capitalized = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
                return <span>{capitalized}</span>;
            }, field: 'company_name', filter: 'agTextColumnFilter', suppressHeaderMenuButton: true, sortable: true, floatingFilter: false
        },
        {
            headerName: 'STATUS',
            field: 'meeting_logs.0.meeting_status',
            cellRenderer: (params) => {
                const status = params?.data?.meeting_logs?.[0]?.meeting_status || '';

                // Convert snake_case to readable text and capitalize first letter
                const formattedStatus = status
                    .split('_')
                    .map((word, index) => index === 0
                        ? word.charAt(0).toUpperCase() + word.slice(1)
                        : word.toLowerCase()
                    )
                    .join(' ');

                // Badge color logic
                const badgeClass =
                    status === 'check_in' ? 'badge bg-primary text-primary-emphasis' :
                        status === 'meeting_start' ? 'badge bg-info text-info-emphasis' :
                            status === 'meeting_end' ? 'badge bg-warning text-warning-emphasis' :
                                status === 'check_out' ? 'badge bg-success text-success-emphasis' :
                                    status === 'rejected' ? 'badge bg-danger text-danger-emphasis' :
                                        'badge bg-secondary text-secondary-emphasis';

                return (
                    <span className={badgeClass}>
                        {formattedStatus || '-'}
                    </span>
                );
            },

            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 140
        },
    ];

    useEffect(() => {
        setLoading(true)
        dispatch(visitorListTodo({ params: { search: "", meeting_person: "", meeting_date: "", meeting_status: "", type: 'all' } })).then(() => setLoading(false))
        dispatch(userListTodo()).then(() => setLoading(false))
    }, [bool])

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head d-flex justify-content-between align-items-center mb-3'>
                            <h5>Visitor List</h5>
                        </div>
                        <Form onSubmit={handleSubmit}>
                            <div className='row  align-items-center' >
                                {/* <div className="col-md-3">
                                    <Form.Group className="mb-2" controlId="search">
                                        <Form.Label className='form_label'>Search</Form.Label>
                                        <Form.Control type="text" placeholder="Search by name/phone/company" name='search' value={values.search} onChange={handleChange} onBlur={handleBlur} />
                                    </Form.Group>
                                </div> */}
                                <div className="col-md-2">
                                    <DatePicker
                                        label_name={'Meeting Date'}
                                        name={'meeting_date'}
                                        value={values.meeting_date}
                                        onChange={(d, str) => setFieldValue('meeting_date', str)}
                                        onBlur={handleBlur}
                                        placeholder={'Select date'}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <SingleSelect label_name={'Status'} reference={statusRef} option={status_option} name='meeting_status'
                                        placeholder={'Status'}
                                        onChange={(e) => setFieldValue('meeting_status', e?.value)}
                                        onBlur={handleBlur}
                                        error={''}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <SingleSelect label_name={'User'} reference={userRef} option={user_option} name='user'
                                        placeholder={'User'}
                                        onChange={(e) => setFieldValue('user', e?.value)}
                                        onBlur={handleBlur}
                                        error={''}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <div className='p-1'></div>
                                    <SaveButton name={'FILTER'} />
                                    <Button type='button' onClick={handleReset} variant="" className='save_btn ms-2'><CircleX /></Button>
                                </div>
                            </div>
                        </Form>
                        {loading || filterLoad ?
                            <div className='text-center'>
                                <Loader />
                            </div>
                            :
                            <DataTable
                                rowData={visitorList}
                                columnDefs={columnDefs}
                                height={'65vh'}
                            />}
                    </div>
                </div>
            </div>
        </>
    )
}


